"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _class = _interopRequireDefault(require("../class"));

var _staticmembers = _interopRequireDefault(require("./_staticmembers"));

var _prototype = _interopRequireDefault(require("./_prototype"));

var _init = _interopRequireDefault(require("../_core/init"));

var _seempleerror = _interopRequireDefault(require("../_helpers/seempleerror"));

_prototype["default"].constructor = function Seemple() {
  if (!(this instanceof Seemple)) {
    throw (0, _seempleerror["default"])('common:call_class');
  }

  (0, _init["default"])(this);
};

var Seemple = (0, _class["default"])(_prototype["default"], _staticmembers["default"]);
var _default = Seemple;
exports["default"] = _default;
//# sourceMappingURL=index.js.map